import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {EnergieService} from '../../../services/rt2012/energie.service';
import {ReleveIndividuel} from '../../../models/rt2012/ReleveIndividuel';
import {faInfoCircle, faPen, faTimes} from '@fortawesome/free-solid-svg-icons';
import {ConsommationsService} from '../../../services/rt2012/consommations.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-historique-releve',
    templateUrl: './historique-releve.component.html',
    styleUrls: ['./historique-releve.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoriqueReleveComponent {

  faInfoCircle = faInfoCircle;
  faPen = faPen;
  faTimes = faTimes;

  @Input() relevesIndividuels: ReleveIndividuel[];
  @Input() isEditable = true;

  @Output() releveDeleted = new EventEmitter();
  @Output() releveUpdated = new EventEmitter();

  @ViewChild('modalEditReleve') modalEditReleveTemplate: TemplateRef<any>;

  editReleve: ReleveIndividuel;
  editModal: NgbModalRef;


  constructor(public energieService: EnergieService,
              public modalService: NgbModal,
              private consommationsService: ConsommationsService) {
  }

  delete(releve: ReleveIndividuel) {
    this.consommationsService.delete(releve).then(value => {
      this.releveDeleted.emit(releve);
    });
  }

  onUpdate() {
    this.releveUpdated.emit();
    this.editModal.close();
  }

  edit(releve: ReleveIndividuel) {
    this.editReleve = releve;
    this.editModal = this.modalService.open(this.modalEditReleveTemplate, {size: 'lg'});
  }
}
